import {CommandSearchRegistry, createGlobalScope, registerRecentActionHandler} from '../../../panel-command-search';
import {
    navigationProvidersFromRegistry,
    operatorDynamicSearchProviders,
    panelActionsProviderFromRegistry,
    replayScopedOrderRecent,
    tutorialsProvider,
} from '../../../../panel-entries';

const GLOBAL_SCOPE = createGlobalScope('main');

let bootstrapped = false;

/**
 * Registers all operator panel-command-search providers and recent-action handlers exactly once.
 * Idempotent — safe to invoke from multiple mounts (e.g. React StrictMode double-invoke).
 */
export const bootstrapPanelCommandSearch = (): void => {
    if (bootstrapped) {
        return;
    }
    bootstrapped = true;

    CommandSearchRegistry.registerMany([
        ...navigationProvidersFromRegistry,
        panelActionsProviderFromRegistry,
        tutorialsProvider,
        ...operatorDynamicSearchProviders,
    ]);

    CommandSearchRegistry.mount('navigation-general', {scope: GLOBAL_SCOPE});
    CommandSearchRegistry.mount('panel-actions', {scope: GLOBAL_SCOPE});
    CommandSearchRegistry.mount('tutorials', {scope: GLOBAL_SCOPE});
    operatorDynamicSearchProviders.forEach((provider) => {
        CommandSearchRegistry.mount(provider.id, {scope: GLOBAL_SCOPE});
    });

    registerRecentActionHandler('navigate', (payload, ctx) => {
        const to = payload.to;
        if (typeof to === 'string') {
            ctx.navigate(to);
        }
    });

    registerRecentActionHandler('scoped-order', (payload, ctx) => replayScopedOrderRecent(payload, ctx));

    registerRecentActionHandler('settings', (_payload, ctx) => {
        (ctx.services as {openSettings?: () => void} | undefined)?.openSettings?.();
    });

    registerRecentActionHandler('support', (_payload, ctx) => {
        (ctx.services as {openSupportChat?: () => void} | undefined)?.openSupportChat?.();
    });

    registerRecentActionHandler('logout', (_payload, ctx) => {
        (ctx.services as {openLogoutDialog?: () => void} | undefined)?.openLogoutDialog?.();
    });

    registerRecentActionHandler('quick-order', (_payload, ctx) => {
        (ctx.services as {openQuickOrder?: () => void} | undefined)?.openQuickOrder?.();
    });

    registerRecentActionHandler('tutorial', (payload) => {
        const href = payload.href;
        if (typeof href === 'string') {
            window.open(href, '_blank', 'noopener,noreferrer');
        }
    });
};
